(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nac-banner-rotator"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('nac-banner-rotator')) return;

    class NacBannerRotator extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;
        this.count = this.track.children.length;
        if (this.count < 2) return;
        if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.ms = Math.max(2, Number(this.dataset.interval) || 3) * 1000;

        // One-time, at page load: copy the first slide to the end so the loop wraps seamlessly.
        // After this, rotation only changes the scroll position, never the page itself.
        if (!Shopify.designMode) {
          const clone = this.track.firstElementChild.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          this.track.appendChild(clone);
        }

        this.hold = false;
        this.inView = false;
        this.io = new IntersectionObserver(([entry]) => {
          this.inView = entry.isIntersecting;
          this.schedule();
        }, { threshold: 0.2 });
        this.io.observe(this);

        const holdOn = () => { this.hold = true; clearTimeout(this.timer); };
        const holdOff = () => { this.hold = false; this.schedule(); };
        this.track.addEventListener('touchstart', holdOn, { passive: true });
        this.track.addEventListener('touchend', holdOff, { passive: true });
        this.track.addEventListener('touchcancel', holdOff, { passive: true });
        this.track.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') holdOn(); });
        this.track.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') holdOff(); });
        this.track.addEventListener('scroll', () => {
          clearTimeout(this.settle);
          this.settle = setTimeout(() => this.wrap(), 150);
        }, { passive: true });
        this.onVisibility = () => this.schedule();
        document.addEventListener('visibilitychange', this.onVisibility);
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        clearTimeout(this.settle);
        this.io?.disconnect();
        document.removeEventListener('visibilitychange', this.onVisibility);
      }

      wrap() {
        const w = this.track.clientWidth;
        if (w && this.track.children.length > this.count && this.track.scrollLeft >= w * this.count - 2) {
          this.track.scrollLeft -= w * this.count;
        }
        this.schedule();
      }

      schedule() {
        clearTimeout(this.timer);
        if (this.hold || !this.inView || document.hidden) return;
        this.timer = setTimeout(() => this.next(), this.ms);
      }

      next() {
        const w = this.track.clientWidth;
        if (!w) return;
        const max = this.track.scrollWidth - w;
        let left = (Math.round(this.track.scrollLeft / w) + 1) * w;
        if (left > max + 2) left = 0;
        this.track.scrollTo({ left, behavior: 'smooth' });
      }
    }

    customElements.define('nac-banner-rotator', NacBannerRotator);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nac-video-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('nac-video-slider')) return;

    const MAX_LIVE = 18; // most videos allowed to hold a decoder at once

    function resolveVideoSrc(url) { const m = url.match(/^((?:https?:)?\/\/[^/]+)\/cdn\/shop\/videos\/c\/vp\/([a-f0-9]{32})\/\2\.[^?#]+\.mp4/); return m ? `${m[1]}/cdn/shop/videos/c/o/v/${m[2]}.mp4` : url; }

    class NacVideoSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;
        this.cards = [...this.querySelectorAll('[data-card]')];
        // Seamless loop: once, at page load, append copies of the first few cards
        // (just enough to fill one screen) so the row can wrap without rewinding.
        this.loop = this.dataset.autoplay === 'true' && !(window.Shopify && Shopify.designMode) && this.cards.length > 1;
        if (this.loop) {
          const viewW = this.track.clientWidth;
          const frag = document.createDocumentFragment();
          let filled = 0;
          for (const card of this.cards) {
            const clone = card.cloneNode(true);
            clone.removeAttribute('data-card');
            clone.setAttribute('data-clone', '');
            clone.setAttribute('aria-hidden', 'true');
            clone.querySelectorAll('a, button').forEach((el) => el.setAttribute('tabindex', '-1'));
            frag.appendChild(clone);
            filled += card.offsetWidth;
            if (filled >= viewW + card.offsetWidth) break;
          }
          this.track.appendChild(frag);
        }
        this.speed = Number(this.dataset.speed) || 50;
        this.auto = this.dataset.autoplay === 'true' && !matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.pos = this.track.scrollLeft;
        this.hold = false;
        this.inView = false;
        this.returning = false;
        this.visible = new Set();
        this.live = [];
        this.tick = this.tick.bind(this);

        // Attach every video's file once, up front. preload="none" means nothing downloads until a
        // video actually plays, and the page then never changes while the rows scroll
        // (ad-blocker extensions rescan the whole page after every change).
        this.querySelectorAll('video[data-src]').forEach((v) => {
          if (!v.getAttribute('src')) v.src = resolveVideoSrc(v.dataset.src);
        });

        this.measure();
        this.resizeObserver = new ResizeObserver(() => this.measure());
        this.resizeObserver.observe(this.track);

        // Videos: only those visible inside the row get a file and play
        this.videoObserver = new IntersectionObserver((entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting) { this.visible.add(e.target); this.activate(e.target); }
            else { this.visible.delete(e.target); e.target.pause(); }
          });
        }, { root: this.track, threshold: 0.15 });
        this.querySelectorAll('video').forEach((v) => this.videoObserver.observe(v));

        // Section: pause everything when it is scrolled off the page
        this.sectionObserver = new IntersectionObserver(([e]) => {
          this.inView = e.isIntersecting;
          if (this.inView) { this.visible.forEach((v) => this.activate(v)); this.start(); }
          else { this.live.forEach((v) => v.pause()); this.stop(); }
        }, { threshold: 0.05 });
        this.sectionObserver.observe(this);

        // Arrows
        this.querySelector('[data-prev]')?.addEventListener('click', () => this.nudge(-1));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.nudge(1));

        // Pause drift while the shopper interacts
        this.track.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') this.hold = true; });
        this.track.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse' && !this.dragging) this.resumeSoon(0); });
        this.track.addEventListener('touchstart', () => { this.hold = true; clearTimeout(this.resumeTimer); }, { passive: true });
        this.track.addEventListener('touchend', () => this.resumeSoon(3000), { passive: true });
        this.track.addEventListener('wheel', () => { if (!this.track.matches(':hover')) this.resumeSoon(3000); }, { passive: true });

        // Mouse drag on desktop
        this.track.addEventListener('pointerdown', (e) => {
          if (e.pointerType !== 'mouse' || e.button !== 0) return;
          this.dragging = true; this.hold = true;
          this.dragX = e.clientX; this.dragLeft = this.track.scrollLeft;
          this.track.classList.add('is-dragging');
          this.track.setPointerCapture(e.pointerId);
        });
        this.track.addEventListener('pointermove', (e) => {
          if (this.dragging) this.track.scrollLeft = this.dragLeft - (e.clientX - this.dragX);
        });
        const endDrag = () => {
          if (!this.dragging) return;
          this.dragging = false;
          this.track.classList.remove('is-dragging');
          if (!this.track.matches(':hover')) this.resumeSoon(3000);
        };
        this.track.addEventListener('pointerup', endDrag);
        this.track.addEventListener('pointercancel', endDrag);

        document.addEventListener('visibilitychange', this.onVisibility = () => {
          if (document.hidden) this.live.forEach((v) => v.pause());
          else if (this.inView) this.visible.forEach((v) => this.activate(v));
        });

        // Theme editor: jump to the selected video
        this.addEventListener('shopify:block:select', (e) => {
          this.hold = true;
          this.track.scrollTo({ left: e.target.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
        });
        this.addEventListener('shopify:block:deselect', () => this.resumeSoon(1000));
      }

      disconnectedCallback() {
        this.stop();
        clearTimeout(this.resumeTimer);
        this.videoObserver?.disconnect();
        this.sectionObserver?.disconnect();
        this.resizeObserver?.disconnect();
        document.removeEventListener('visibilitychange', this.onVisibility);
      }

      // Width of one full set of cards = where the first copy starts
      measure() {
        const firstClone = this.track.querySelector('[data-clone]');
        this.setW = firstClone && this.cards[0] ? firstClone.offsetLeft - this.cards[0].offsetLeft : 0;
      }

      activate(video) {
        if (!this.inView || document.hidden) return;
        if (!video.getAttribute('src') && video.dataset.src) video.src = resolveVideoSrc(video.dataset.src);
        this.live = this.live.filter((v) => v !== video);
        this.live.push(video);
        // Over budget: free the oldest videos that are no longer visible
        for (let i = 0; this.live.length > MAX_LIVE && i < this.live.length; ) {
          const v = this.live[i];
          if (!this.visible.has(v)) { this.release(v); this.live.splice(i, 1); } else i++;
        }
        const p = video.play();
        if (p) p.catch(() => {});
      }

      release(video) {
        video.pause();
        video.removeAttribute('src');
        video.load(); // frees the decoder, especially on iPhone
      }

      resumeSoon(ms) {
        clearTimeout(this.resumeTimer);
        this.resumeTimer = setTimeout(() => { this.hold = false; this.pos = this.track.scrollLeft; }, ms);
      }

      nudge(dir) {
        this.hold = true;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const step = (this.cards[0]?.offsetWidth || 0) + gap;
        this.track.scrollBy({ left: dir * step, behavior: 'smooth' });
        this.resumeSoon(3000);
      }

      start() {
        if (!this.auto || this.frame) return;
        this.last = null;
        this.frame = requestAnimationFrame(this.tick);
      }

      stop() {
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = null;
      }

      tick(time) {
        this.frame = requestAnimationFrame(this.tick);
        const dt = this.last == null ? 0 : Math.min(time - this.last, 50) / 1000;
        this.last = time;
        if (this.hold || this.returning || document.hidden) return;
        const max = this.track.scrollWidth - this.track.clientWidth;
        if (max <= 0) return;
        // Shopper moved the row? Continue from where they left it
        if (Math.abs(this.track.scrollLeft - this.pos) > 3) this.pos = this.track.scrollLeft;
        this.pos += this.speed * dt;
        if (this.loop && this.setW > 0) {
          // Seamless loop: past one full set, jump back by exactly one set (the copies look identical)
          if (this.pos >= this.setW) this.pos -= this.setW;
          this.track.scrollLeft = this.pos;
          return;
        }
        if (this.pos >= max) {
          this.pos = max;
          this.track.scrollLeft = max;
          // Reached the end: short pause, glide back to the start, carry on
          this.returning = true;
          setTimeout(() => {
            this.track.scrollTo({ left: 0, behavior: 'smooth' });
            setTimeout(() => { this.pos = this.track.scrollLeft; this.returning = false; }, 1500);
          }, 1200);
          return;
        }
        this.track.scrollLeft = this.pos;
      }
    }

    customElements.define('nac-video-slider', NacVideoSlider);
  })();

  } catch(e) { console.error(e); }
})();
})();
